import { CELL, GROUND } from '../core/config';
import type { Building } from './city';

/** Authoring uses the same occupied cell parts as live collision. Coordinates
 * are cell-grid centres on a represented floor, with full standing clearance. */
export function roomStandingClear(
  building: Building,
  fixtures: Building[],
  floor: number,
  floorHeight: number,
  x: number,
  z: number,
): boolean {
  return roomClearance(building, fixtures, floor, floorHeight)(x, z);
}
export function roomClearance(
  building: Building,
  fixtures: Building[],
  floor: number,
  floorHeight: number,
): (x: number, z: number) => boolean {
  const floorY = floor * floorHeight,
    foot = (building.baseY ?? GROUND) + (floorY + 1) * CELL,
    supported = new Set(building.cells.filter((c) => c.y === floorY).map((c) => `${c.x},${c.z}`)),
    boxes: { x: number; z: number; w: number; d: number }[] = [];
  for (const b of [building, ...fixtures])
    for (const c of b.cells)
      for (const s of c.parts ?? [c.bounds ?? { x: 0, y: 0, z: 0, w: 1, h: 1, d: 1 }]) {
        const a = b.x + (c.x + s.x) * CELL,
          y = (b.baseY ?? GROUND) + (c.y + s.y) * CELL,
          q = b.z + (c.z + s.z) * CELL;
        if (y < foot + 1.72 && y + s.h * CELL > foot + 0.06)
          boxes.push({ x: a, z: q, w: s.w * CELL, d: s.d * CELL });
      }
  return (x, z) => {
    if (!supported.has(`${Math.floor(x)},${Math.floor(z)}`)) return false;
    const X = building.x + (x + 0.5) * CELL,
      Z = building.z + (z + 0.5) * CELL;
    return !boxes.some(
      (b) => b.x < X + 0.28 && b.x + b.w > X - 0.28 && b.z < Z + 0.28 && b.z + b.d > Z - 0.28,
    );
  };
}
